import React from 'react';
import { useHistory } from 'react-router';
import { useMount } from 'react-use';
import { clearUser } from '../utilities/storage';
var Logout = function() {
    var history = useHistory();
    useMount(function() {
        clearUser();
        history.replace('/login');
    });
    return /*#__PURE__*/ React.createElement("div", null);
};
export default Logout;
